export default {
  GET_SETTINGS_REQUEST: "GET_SETTINGS_REQUEST",
  GET_SETTINGS_RESPONSE: "GET_SETTINGS_RESPONSE",
  POST_SETTINGS_REQUEST: "POST_SETTINGS_REQUEST",
  POST_SETTINGS_RESPONSE: "POST_SETTINGS_RESPONSE",
  PUT_SETTINGS_REQUEST: "PUT_SETTINGS_REQUEST",
  PUT_SETTINGS_RESPONSE: "PUT_SETTINGS_RESPONSE",
  POST_SETTINGS_RESPONSE_CLEAR: "POST_SETTINGS_RESPONSE_CLEAR",
  //CUSTOM ROLES
  GET_CUSTOM_ROLE_LIST_REQUEST: "GET_CUSTOM_ROLE_LIST_REQUEST",
  GET_CUSTOM_ROLE_LIST_RESPONSE: "GET_CUSTOM_ROLE_LIST_RESPONSE",
  GET_CUSTOM_ROLE_REQUEST: "GET_CUSTOM_ROLE_REQUEST",
  GET_CUSTOM_ROLE_RESPONSE: "GET_CUSTOM_ROLE_RESPONSE",
  POST_CUSTOM_ROLE_REQUEST: "POST_CUSTOM_ROLE_REQUEST",
  POST_CUSTOM_ROLE_RESPONSE: "POST_CUSTOM_ROLE_RESPONSE",
  PUT_CUSTOM_ROLE_REQUEST: "PUT_CUSTOM_ROLE_REQUEST",
  PUT_CUSTOM_ROLE_RESPONSE: "PUT_CUSTOM_ROLE_RESPONSE",
  PUT_CUSTOM_ROLE_STATUS_REQUEST: "PUT_CUSTOM_ROLE_STATUS_REQUEST",
  PUT_CUSTOM_ROLE_STATUS_RESPONSE: "PUT_CUSTOM_ROLE_STATUS_RESPONSE",
  POST_CUSTOM_ROLE_RESPONSE_CLEAR: "POST_CUSTOM_ROLE_RESPONSE_CLEAR",
  GET_ROLE_BY_PERMISSION_REQUEST: "GET_ROLE_BY_PERMISSION_REQUEST",
  GET_ROLE_BY_PERMISSION_RESPONSE: "GET_ROLE_BY_PERMISSION_RESPONSE",
  PUT_ROLE_BY_PERMISSION_REQUEST: "PUT_ROLE_BY_PERMISSION_REQUEST",
  PUT_ROLE_BY_PERMISSION_RESPONSE: "PUT_ROLE_BY_PERMISSION_RESPONSE",
  PUT_ROLE_BY_PERMISSION_RESPONSE_CLEAR:
    "PUT_ROLE_BY_PERMISSION_RESPONSE_CLEAR",
};
